export const LARGE_SUFFIX = 'large'
export const MIDDLE_SUFFIX = 'middle'
export const SMALL_SUFFIX = 'small'
export const AVATAR_SUFFIX = 'avatar'
export const THUMBNAIL_SUFFIX = 'thumbnail' // 缩略图，用于大量在展示时使用

/**
 * 添加阿里云后缀
 * @param  String  src     图片链接地址
 * @param  String  suffix  后缀名
 * @return String  新的图片地址
*/
export const addImageSuffix = (src, suffix = 'large') => {
  let image = src

  if (image && image.indexOf('wanfangche.com') >= 0) {
    let [url] = image.split('?')
    image = url + '?x-oss-process=style/' + suffix
  }

  return image
}
